module.exports = __webpack_public_path__ + "static/media/right-round-active.740e5594.svg";